// import React from 'react';
import LocalStorage from './localStorage';
// import { MessageOutlined, CloseOutlined } from '@ant-design/icons';
// import { Tooltip, Typography, Tag } from 'antd';
// const { Text, Paragraph } = Typography;
// import styles from '../pages/CustomTooltip1/CustomTooltip.module.css';
// import CustomTooltip from '../pages/CustomTooltip/CustomTooltip.js';

export const getLoggedInUser = () => {
  const loginUser = LocalStorage.getItem('MAT-User') || '';
  const user = loginUser || { user: null };
  return {
    ...user,
    loggedIn: loginUser !== ''
  };
};

export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      resolve(fileReader.result);
    };

    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

export const blobToFile = (blob, fileName) => {
  blob.lastModified = new Date().getTime();
  blob.name = fileName;

  return blob;
};

export const removeDuplicatesFromArray = (arr, key) => {
  const uniqueArr = [];

  const unique = arr.filter((item) => {
    const isDuplicate = uniqueArr.includes(item[`${key}`]);

    if (!isDuplicate) {
      uniqueArr.push(item[`${key}`]);

      return true;
    }

    return false;
  });

  return unique;
};
